.inputFieldMasked {
  opacity: 0;
  height: 0;
  z-index: -1;

  label,
  div,
  p {
    height: 0;
  }
}
